import React from 'react'
import { Descriptions, Modal as AntModal, Space, Tag, Typography } from 'antd'
import { Client } from '~/Services/Clients'
import { useTranslation } from 'react-i18next';

interface ClientDetailModalProps {
  client: Client | null
  detailLoading: boolean
  visible: boolean
  onCancel: () => void
}

export const ClientDetailModal = ({
  client,
  detailLoading,
  visible,
  onCancel,
}: ClientDetailModalProps) => {
 const { t } = useTranslation();

  return (
    <AntModal
      title={client?.clientName || t('admin.clientDetail')}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={720}
      destroyOnClose
    >
      {detailLoading ? (
        <Typography.Text>{t('admin.loading')}</Typography.Text>
      ) : client ? (
      <Space direction="vertical" size={16} style={{ display: 'flex' }}>
        <Descriptions bordered column={1} size="middle">
          <Descriptions.Item label={t('admin.clientId')}>
            {client.clientId}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.clientName')}>
            {client.clientName}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.enabled')}>
            {client.enabled ? (
              <Tag color="green">Enabled</Tag>
            ) : (
              <Tag color="red">Disabled</Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.allowOfflineAccess')}>
            {client.allowOfflineAccess ? 'Yes' : 'No'}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.allowAccessTokensViaBrowser')}>
            {client.allowAccessTokensViaBrowser ? 'Yes' : 'No'}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.updateAccessTokenClaimsOnRefresh')}>
            {client.updateAccessTokenClaimsOnRefresh ? 'Yes' : 'No'}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.refreshTokenExpiration')}>
            {client.refreshTokenExpiration}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.requireClientSecret')}>
            {client.requireClientSecret ? 'Yes' : 'No'}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.allowedGrantTypes')}>
            <Space wrap>
              {(client.allowedGrantTypes || []).map(item => (
                <Tag key={item}>{item}</Tag>
              ))}
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.allowedScopes')}>
            <Space wrap>
              {(client.allowedScopes || []).map(item => (
                <Tag key={item}>{item}</Tag>
              ))}
            </Space>
          </Descriptions.Item>
        </Descriptions>
      </Space>
    ) : (
      <Typography.Text>{t('admin.noClientSelected')}</Typography.Text>
    )}
    </AntModal>
  )
}

